import axios from 'axios'

export async function validateGoogleCaptcha(value) {
  return (await axios.post('/kiosk-mobile/reCaptcha-validate', { token: value })).data
}
